// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export type xUpsellsProductsType = {
    isLoading: boolean;
    productsInfo: { [erp: string]: ProductInfo };
};

const initialState: xUpsellsProductsType = {
    isLoading: false,
    productsInfo: {},
};

const xUpsellsProducts = createTypedReducerWithImmer(initialState, {
    "UpsellsProducts/AddProductsInfo": (draft: Draft<xUpsellsProductsType>, actions: { productsInfo: any }) => {
        draft.productsInfo = { ...draft.productsInfo, ...actions.productsInfo };
    },
});

(reducers as any).xUpsellsProducts = xUpsellsProducts;

export type xUpsellsProductsState = {
    xUpsellsProducts: xUpsellsProductsType;
} & ApplicationState;

type xUpsellsProductsReducers = {
    xUpsellsProducts: typeof xUpsellsProducts;
};

export type upsellsProductsActions =
    | Parameters<xUpsellsProductsReducers[keyof xUpsellsProductsReducers]>[1]
    | AnyAction;
